import api from '../services/api';

export function getApiOrigin(): string {
  const base = (api.defaults.baseURL || '').replace(/\/$/, '');
  return base.replace(/\/api$/i, '');
}

export function absolutizeContentMediaUrls(html: string): string {
  if (!html) return html;
  const origin = getApiOrigin();
  if (!origin) return html;
  return html
    .replace(/(src=["'])(\/api\/content\/media-staging[^"']*)(["'])/gi, (_, a, path, c) => `${a}${origin}${path}${c}`)
    .replace(/(src=["'])(\/api\/content\/media[^"']*)(["'])/gi, (_, a, path, c) => `${a}${origin}${path}${c}`);
}

export function appendMediaAccessTokenToHtml(html: string): string {
  const token = localStorage.getItem('token');
  if (!token || !html) return html;
  const enc = encodeURIComponent(token);
  return html.replace(
    /(src=["'])([^"']*\/api\/content\/(?:media-staging|media)[^"']*)(["'])/gi,
    (full, q1, url, q2) => {
      if ((url as string).includes('access_token=')) return full;
      const sep = (url as string).includes('?') ? '&' : '?';
      return `${q1}${url}${sep}access_token=${enc}${q2}`;
    },
  );
}

/** HTML ready for Quill or read-only preview (absolute media URLs + token query where needed). */
export function prepareContentRichPreviewHtml(html: string | undefined): string {
  if (!html) return '';
  if (html.trim().startsWith('{')) return html;
  return appendMediaAccessTokenToHtml(absolutizeContentMediaUrls(html));
}

/** True if raw editor value (HTML, plain text, or Quill Delta JSON) is non-empty for preview purposes. */
export function rawStringHasPreviewableBody(raw: string | undefined): boolean {
  const r = (raw ?? '').trim();
  if (!r) return false;
  if (r.startsWith('{')) {
    try {
      const doc = JSON.parse(r) as { ops?: unknown[] };
      return Array.isArray(doc?.ops) && doc.ops.length > 0;
    } catch {
      return true;
    }
  }
  const stripped = r.replace(/<[^>]*>/g, '').trim();
  if (stripped.length > 0) return true;
  return /<(img|video|audio)\b/i.test(r);
}
